import { Component, Injector, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'

import { DialogService } from '@shared/dialogs/dialog.service'
import { DriverDocumentService } from './dirver-document.service'
import { DriverDocumentListDataSource } from './driver-document-list.datasource'
import { DocumentService } from '../documents/document.service'
import { DocumentList } from '../documents/document-list.component'
import { PermissionsService } from '@shared/services/permissions.service'
import { PermissionsSource, PermissionSourceType } from '@core/types/permissions.source'

@Component({
  selector: 'lin-driver-document-list',
  templateUrl: './driver-document-list.component.html',
  standalone: false,
})
export class DriverDocumentListComponent extends DocumentList implements OnInit {
  columns = ['fullName', 'title', 'status', 'remainingDays', 'issueDate', 'expDate', 'edit', 'archive', 'delete']
  columnsMandatory = ['edit', 'archive', 'delete']
  dataSource: DriverDocumentListDataSource
  driverId: number
  fileName = 'Driver Documents'
  readonly PermissionsSource = PermissionsSource

  constructor(
    dialogService: DialogService,
    documentService: DocumentService,
    translateService: TranslateService,
    injector: Injector,
    private driverDocumentService: DriverDocumentService,
    private permissionsService: PermissionsService,
    private route: ActivatedRoute,
  ) {
    super(dialogService, documentService, translateService, injector)
  }

  ngOnInit() {
    this.driverId = +this.route.parent.snapshot.paramMap.get('id')
    this.driverId && this.filterColumns('fullName')

    !this.hasPermission(PermissionsSource['DRIVERS.DOCUMENTS_LIST.EDIT']) && this.filterColumns('edit')
    !this.hasPermission(PermissionsSource['DRIVERS.DOCUMENTS_LIST.DELETE']) && this.filterColumns('delete')
    !this.hasPermission(PermissionsSource['DRIVERS.DOCUMENTS_LIST.ARCHIVE']) && this.filterColumns('archive')

    super.ngOnInit()
    this.dataSource = new DriverDocumentListDataSource(
      this.driverId || null,
      this.driverDocumentService,
      this.sort,
      this.paginator,
      this.form,
    )
  }

  hasPermission(permissionType: PermissionSourceType): boolean {
    return this.permissionsService.hasPermissionSync(permissionType)
  }
}
